import styled from 'styled-components';

import Dots from '../Loading/variants/Dots';

export const StyledSplashContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fafafa;
  z-index: 1201;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledDots = styled(Dots)`
  position: fixed;
  bottom: 20px;
`;
